import React, { useEffect, useState } from "react";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import InputComponent from "../../../../components/Tenant/InputComponent/InputComponent";
import { toast } from "react-hot-toast";
import {
  useAddAppVideoMutation,
  useGetAppVideoTypesMutation,
} from "../../../../features/tenant/appVideo/appVideoApi";
import { getVendorName } from "../../../../utils/getVendorName";
import { useLocation, useNavigate } from "react-router-dom";
import { hasPermission } from "../../../../utils/hasPermission";
import SelectComponent from "../../../../components/Tenant/SelectComponent/SelectComponent";
import {
  pushNotificationTypeApi,
  useCreatePushNotificationTypeMutation,
  useUpdatePushNotificationTypeByIdMutation,
} from "../../../../features/tenant/PushNotificationType/pushNotificationTypeAPi";
import { useUploadSingleFileMutation } from "../../../../features/admin/imageUpload/imageUploadApi";

const AddPushNotificationsType = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // console.log("object", location);
  const isUpdate = location.state.isUpdate ? true : false;
  const data = location.state.row;
  // console.log("Data", data);

  const [title, setTitle] = useState(data?.title ? data.title : "");

  const [notificationType, setNotificationType] = useState(
    data?.notification_type ? data.notification_type : ""
  );
  const [body, setBody] = useState(data?.body ? data.body : "");
  const [image, setImage] = useState(data?.image ? data.image : "");
  // const [images, setImages] = useState();

  const [
    addPushNotificationTypeFunc,
    {
      data: addPushNotificationTypeData,
      isLoading: addPushNotificationTypeIsLoading,
      error: addPushNotificationTypeError,
    },
  ] = useCreatePushNotificationTypeMutation();


  const [
    updatePushNotificationTypeById,
    {
      data: updatePushNotificationTypeByIdData,
      isLoading: updatePushNotificationTypeByIdIsLoading,
      error: updatePushNotificationTypeByIdError,
    },
  ] = useUpdatePushNotificationTypeByIdMutation();


  const [
    uploadImage,
    {
      data: uploadImageData,
      isLoading: uploadImageIsLoading,
      error: uploadImageError,
    },
  ] = useUploadSingleFileMutation();


  const previewImage = (event) => {
    // setFormImg(event.target.files[0]);
    const formData = new FormData();
    formData.append("image", event.target.files[0]);
    uploadImage({
      body: formData,
    });
  };

  useEffect(() => {
    toast.dismiss();
    if (uploadImageData) {
      // console.log("success image upload", uploadImageData.body);
      setImage(uploadImageData.body.fileLink);
    }
    if (uploadImageError) {
      toast.error("Image upload failed");
    }

    if (uploadImageIsLoading) {
      toast.loading("Uploading your image...", { id: "uploadImageLoading" });
    }
  }, [uploadImageData, uploadImageError, uploadImageIsLoading]);


  useEffect(() => {
    // const hasViewPermission = hasPermission("video");
    // if (!hasViewPermission) {
    //   navigate(`/genefied/${getVendorName()}/`);
    // }

    if (addPushNotificationTypeData) {
      toast.success("Push Notifications Type Added !");
      navigate(`/genefied/${getVendorName()}/push-notification`);
    }
  }, [addPushNotificationTypeData, addPushNotificationTypeError]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!notificationType || !notificationType.trim()) {
      toast.error("Please provide notification type", {
        id: "imageError",
      });
      return;
    }

    if (!title || !title.trim()) {
      toast.error("Please provide title", {
        id: "imageError",
      });
      return;
    }

    if (!body || !body.trim()) {
      toast.error("Please provide notification body", {
        id: "imageError",
      });
      return;
    }

    // if (!image) {
    //   toast.error("Please provide image", {
    //     id: "imageError",
    //   });
    //   return;
    // }

    addPushNotificationTypeFunc({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        notification_type: notificationType.trim(),
        title: title.trim(),
        body: body.trim(),
        image: image,
      },
    });
  };
  const handleUpdate = (e) => {
    e.preventDefault();

    // console.log(notificationType);
    // console.log(title);
    // console.log(body);
    // console.log(image);

    if (!notificationType || !notificationType.trim()) {
      toast.error("Please provide notification type", {
        id: "imageError",
      });
      return;
    }

    if (!title || !title.trim()) {
      toast.error("Please provide title", {
        id: "imageError",
      });
      return;
    }

    if (!body || !body.trim()) {
      toast.error("Please provide notification body", {
        id: "imageError",
      });
      return;
    }

    // if (!image) {
    //   toast.error("Please provide image", {
    //     id: "imageError",
    //   });
    //   return;
    // }

    updatePushNotificationTypeById(
      {
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: {
          title: title.trim(),
          body: body.trim(),
          image: image,
        },
        id: data.id
      }
    )

    return;
  };

  useEffect(() => {
    if (updatePushNotificationTypeByIdData) {
      toast.success("Push Notifications Type Added !");
      navigate(`/genefied/${getVendorName()}/push-notification`);
    }
    if (updatePushNotificationTypeByIdError) {
      toast.error(updatePushNotificationTypeByIdError.data.message, {
        id: "updatePushNotificationTypeByIdError"
      });
    }
  }, [updatePushNotificationTypeByIdData, updatePushNotificationTypeByIdError])
  return (
    <>
      {" "}
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Add Push Notifications Type
            <LinksComponent />
          </div>
          <div className="p-3">
            <form className="p-3 w-full bg-white shadow rounded-lg">
              <div className="w-full  flex justify-center space-x-4">
                <div className="mb-3 w-1/2">
                  <div className="w-full">
                    <InputComponent
                      name={"Notification Type"}
                      type={"textarea"}
                      value={notificationType}
                      setValue={setNotificationType}
                      required={true}
                      placeholder={"Enter Notification Type"}
                      disabled={isUpdate}
                    />
                  </div>
                </div>

                <div className="mb-3 w-1/2">
                  <div className="w-full">
                    <InputComponent
                      name={"Title"}
                      type={"textarea"}
                      value={title}
                      setValue={setTitle}
                      required={true}
                      placeholder={"Enter Title"}
                    />
                  </div>
                </div>

                <div className="mb-3 w-1/2">
                  <div className="w-full">
                    <InputComponent
                      name={"body"}
                      type={"textarea"}
                      value={body}
                      setValue={setBody}
                      required={true}
                      placeholder={"Enter Body"}
                    />
                  </div>
                </div>

              </div>
              <div className="w-full flex justify-center flex-col ">
                <div className="w-full flex justify-center  ">
                  <div className="flex items-center justify-center w-full">
                    <label
                      for="dropzone-file"
                      className="flex flex-col items-center justify-center w-full h-48 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                    >
                      <div className="flex flex-col items-center justify-center ">
                        <svg
                          aria-hidden="true"
                          className="w-40 h-40 mb-3 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            stroke-linecap="round"
                            strokeLinejoin="round"
                            stroke-width="2"
                            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                          ></path>
                        </svg>
                        <p className="mb-2 text-sm text-gray-500">
                          <span className="font-semibold block">
                            Upload Image
                          </span>{" "}
                        </p>
                        <p className="text-xs text-gray-500">PNG or JPG</p>
                      </div>
                      <input
                        id="dropzone-file"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => previewImage(e)}
                      />
                    </label>
                  </div>
                </div>

                {image && (
                  <img
                    src={image}
                    alt=""
                    srcset=""
                    className="flex items-center justify-center h-16 w-16 mt-2 mb-2 border border-gray-300 p-2 m-auto rounded-md"
                  />
                )}
              </div>

              <div className="flex justify-center mt-4">
                {isUpdate ? (
                  <button
                    type="submit"
                    onClick={(e) => handleUpdate(e)}
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  >
                    Update
                  </button>
                ) : (
                  <>
                    {" "}
                    <button
                      type="submit"
                      onClick={(e) => handleSubmit(e)}
                      className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                    >
                      Add
                    </button>
                  </>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPushNotificationsType;
